<template>
  <div class="messages">
    <div class="messages__list">
      <div
        class="messages__item messages__item--path"
        :class="isWarning ? 'warning' : ''"
        v-for="message in messages"
        :key="message.Id"
      >
        <lennoc-icon :image="messageIcon(message)" :class="messageIcon(message)" />
        <h3 class="messages__title title--m">{{ messageHeader(message) }}</h3>
        <p class="timestamp">{{ formatDateTime(message.TimeStamp) }}</p>
        <base-flex-message :message="messageBody(message)"></base-flex-message>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/datetime'
import { mapGetters } from 'vuex'
import bbob from '@bbob/html'
import presetHTML5 from '@bbob/preset-html5'

export default {
  name: 'ClaimChildMessages',
  props: {
    rootMessage: {
      type: Object,
      required: true
    },
    isWarning: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    }),
    titleCustomer () {
      return this.getUiString(['claim_details', 'claim', 'your_message'])
    },
    messages () {
      const msgs = this.rootMessage.Children.filter(
        m => !m.ContainsFile
      ).reverse()
      return msgs
    }
  },
  methods: {
    messageIcon (message) {
      return message.DocumentAction === 'MessageCustomer'
        ? 'user'
        : 'logo-icon'
    },
    messageHeader (message) {
      return message.DocumentAction === 'MessageCustomer'
        ? this.titleCustomer
        : message.Description
    },
    messageBody (message) {
      return message.DocumentAction === 'MessageCustomer'
        ? message.Message
        : bbob(message.Message, presetHTML5())
    },
    formatDateTime (date) {
      return formatDate(date, 'datetime')
    }
  }
}
</script>
